import { render, staticRenderFns } from "./VisitorsComponent.vue?vue&type=template&id=4ca16d10&scoped=true&"
import script from "./VisitorsComponent.vue?vue&type=script&lang=js&"
export * from "./VisitorsComponent.vue?vue&type=script&lang=js&"
import style0 from "./VisitorsComponent.vue?vue&type=style&index=0&id=4ca16d10&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca16d10",
  null
  
)

export default component.exports